export function checkPasswordStrength(password) {
    const passwordRegex = new RegExp('^(?=.*[a-zA-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})');

    return passwordRegex.test(password);
}
